import React from "react";
import styled from "styled-components";
import { Table as BsTable } from "react-bootstrap";
import { DetalleVenta } from "../../../services/ventasServicios";
import { currencyFormat } from "../../../utils/numberUtils";

function DetallesVentaTable({ items }: { items: DetalleVenta[] }) {
  return (
    <StyledTable responsive hover>
      <thead>
        <tr>
          <StyledColHeader>Item</StyledColHeader>
          <StyledColHeader>Cant</StyledColHeader>
          <StyledColHeader>Valor</StyledColHeader>
          <StyledColHeader>Subtotal</StyledColHeader>
          <StyledColHeader></StyledColHeader>
        </tr>
      </thead>
      <tbody>
        {items.map((item) => (
          <TableItem key={item.id} item={item} />
        ))}
      </tbody>
    </StyledTable>
  );
}

function TableItem({ item }: { item: DetalleVenta }) {
  return (
    <StyledRow>
      <StyledCell>{item.descripcion}</StyledCell>
      <StyledCell>{item.cantidad}</StyledCell>
      <StyledCell>{currencyFormat(item.valor)}</StyledCell>
      <StyledCell>{currencyFormat(item.cantidad * item.valor)}</StyledCell>
    </StyledRow>
  );
}

const StyledTable = styled(BsTable)``;

const StyledCell = styled("td")``;

const StyledColHeader = styled("th")`
  color: ${(props) => props.theme.colors.main};
`;

const StyledRow = styled("tr")`
  cursor: pointer;
`;

export default DetallesVentaTable;
